import React from 'react';
import PropTypes from 'prop-types';
import {getText} from 'helpers/language-helper';
import {playerUiTexts} from 'data/ui-texts/player-ui-texts';
import {languagesData} from 'data/languages-data';
import Logo from 'components/ui/logo/logo';
import './choose-language.scss';

const ChooseLanguage = ({languageId, handleChooseLanguage}) => {

	const availableLanguages = languagesData;	
	const altLanguage = (languageId === 'en' ? 'da' : 'en');

	return (
		<div className="ChooseLanguage">
			<div className="ChooseLanguage-logoCGL">
				<Logo type="cgl"/>
			</div>
			<div className="ChooseLanguage-content">
				<div className="ChooseLanguage-title">
					<span>{getText(playerUiTexts.chooseLanguage, languageId)}</span>
				</div>
				<div className="ChooseLanguage-subtitle">
					<span>{getText(playerUiTexts.chooseLanguage, altLanguage)}</span>
				</div>
				<div className="ChooseLanguage-languages">
					{availableLanguages.map((language) => {
						return (
							<div 
								key={language.id}
								className={'ChooseLanguage-language ' + language.id}
								onClick={() => {handleChooseLanguage(language.id);}}
							/>
						);
					})}
				</div>
			</div>
		</div>
	);
};

ChooseLanguage.propTypes = {
	languageId: PropTypes.string.isRequired,
	handleChooseLanguage: PropTypes.func.isRequired
};

export default ChooseLanguage;
